// Initial synchronous addin initialization. Should be kept as small as possible to reduce load
// time. This is necessary in an attempt to overcome various race conditions created by Office.js
// on startup.

import { type tagnifiCustomFunction } from '@/init_async';
const initAsyncMod = import('@/init_async');

(window as any).INIT_START_TS = Date.now();

await Office.onReady();

const initComplete = initAsyncMod.then((mod) => mod.initAsync());

const tagnifiFunctionProxy: typeof tagnifiCustomFunction = async (...args) => {
  // Wait for init to complete before executing function
  await initComplete;
  return (await initAsyncMod).tagnifiCustomFunction(...args);
};

if (Office.context.host === Office.HostType.Excel) {
  // Register custom function handler as soon as possible, hopefully before Excel attempts to use it
  // during startup
  CustomFunctions.associate('TAGNIFI', tagnifiFunctionProxy);
}
